<div class="its-plans__toolbar">
    {#if config.canEdit && !data.loading}
        <div class="its-plans__toolbar_items">
            <Link kind="primary-standalone" href={createNewPlanUrl} on:click={createNew}>
                {i18n.addPlan}
            </Link>
            <PlanActions
                {selectedView}
                {data}
                {hideFeaturesForTableView}
                {areAllPlansSelected}
                {topicFilterIds}
                {selectedPlanIds}
                on:endOfActionOnSelectedPlans
            />
        </div>
        {#if !hideFeaturesForTableView && config.canEdit && config.isImportEnabled}
            <UseReadyMadeContentLink
                href={`/Courses/${
                    config.courseId
                }/ImportContent?importTopic=false&returnUrl=${encodeURI(window.location.origin + window.location.pathname)}`}
                linktext={i18n.useReadyMadeContent}
                emptyState={false}
            />
        {/if}
    {/if}
</div>

<script>
    import Link from "@itslearning/prometheus/assets/Navigation/Link/v1/Link.svelte";
    import PlanActions from "../../components/PlanActions/PlanActions.svelte";
    import UseReadyMadeContentLink from "../../components/UseReadyMadeContentLink/UseReadyMadeContentLink.svelte";

    import i18n from "../../i18n";
    import config from "../../config";
    import { createPlan, createPlanV2 } from "../../api";
    import { addBackDestinationParam } from "../../helpers/backLinkHelper";
    import { TOPIC_ID_DESTINATION_QUERY_STRING_PARAMETER } from "../../constants";

    export let data;
    export let selectedView;
    // Added by ITS-86131 and should be removed later.
    export let hideFeaturesForTableView = false;
    export let backExtraParams = null;
    export let areAllPlansSelected = false;
    export let topicFilterIds = [];
    export let selectedPlanIds = {
        set: () => {}
    };

    let createNewPlanUrl = "#";

    const createNew = async event => {
        event.preventDefault();

        const topicId = config.assignToEnabled ? config.topicId : null;

        const planParams = {
            topic: {
                id: topicId
            },
            start: "0000-00-00 00:00:00",
            stop: "0000-00-00 00:00:00"
        };

        const newPlan = config.assignToEnabled ? await createPlanV2(planParams) : await createPlan(planParams);

        if (backExtraParams && backExtraParams[TOPIC_ID_DESTINATION_QUERY_STRING_PARAMETER]) {
            Reflect.deleteProperty(backExtraParams, TOPIC_ID_DESTINATION_QUERY_STRING_PARAMETER);
        }

        createNewPlanUrl = addBackDestinationParam(
            `${config.newPlanUrl}/${newPlan.planId}?pendingPlanId=${newPlan.planId}`,
            backExtraParams
        );

        window.location.href = createNewPlanUrl;

        return false;
    };
</script>
